// Font family comes from the vendored IPC Wealth Design System token
// (--ipc-font-primary => Nunito Sans). Kept as a var so the brand token
// stays the single source of truth; do not hardcode a family here.
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "var(--ipc-font-primary)",
    h1: {
      fontFamily: "var(--ipc-font-primary)",
    },
    h2: {
      fontFamily: "var(--ipc-font-primary)",
    },
    h3: {
      fontFamily: "var(--ipc-font-primary)",
    },
    h4: {
      fontFamily: "var(--ipc-font-primary)",
    },
    h5: {
      fontFamily: "var(--ipc-font-primary)",
    },
    h6: {
      fontFamily: "var(--ipc-font-primary)",
    },
    body1: {
      fontFamily: "var(--ipc-font-primary)",
    },
    body2: {
      fontFamily: "var(--ipc-font-primary)",
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: "var(--ipc-font-primary)",
        },
      },
    },
  },
});

export default theme;
